export default function getTextCase(text: string): 'upper' | 'lower' {
  return text.charAt(0).toLowerCase() === text.charAt(0) ? 'lower' : 'upper'
}
